import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ConsultasService } from '@app/services/consultas.service';
import { RelatorioService } from '@app/services/relatorio.service';
import { UtilitarioService } from '@app/services/utilitario.service';
import { CDSMask } from '@app/utils/cds-mask';
import debounce from '@app/utils/debounce';
import { FiltrosPagasPagar } from './filtros-pagas-pagar';
import { ContasPagar } from '@app/models/contas-pagar';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-pagas-pagar',
  templateUrl: './pagas-pagar.component.html',
  styleUrls: ['./pagas-pagar.component.scss']
})
export class PagasPagarComponent implements OnInit {

  cdsMask: CDSMask = new CDSMask();
  lstUnidades: IdDescricao[];
  lstParticipante: any[] = []
  lstConta: IdDescricao[] = [];
  filtros: FiltrosPagasPagar = new FiltrosPagasPagar();

  checkPagar = true;
  checkPagas = false;
  checkTodas = false;

  tituloRelatorio = '';
  relatorio: ContasPagar[] = [];
  relatorioPagarPagas: ContasPagar[] = [];

  totalPagar = 0;
  totalLiberadoPagar = 0;
  totalPagas = 0;
  pesquisando = false;

  dataRelatorio: Date;
  _debounce: any;
  _pesquisa: any;

  nomeParticipanteRelatorio: string = "";

  constructor(
    private relatorioService: RelatorioService,
    private consultasService: ConsultasService,
    @Inject(ToastrService) public toastr: ToastrService
  ) { }

  ngOnInit() {
    this.filtros.UnidadeId = [];
    this.filtros.TipoData = 'Vencimento';
    this.consultasService.consultar('UNIDADE_C_RATEIO').subscribe(data => this.lstUnidades = data);
    this.consultasService.consultar('CONTA').subscribe(data => this.lstConta = data);
  }

  montaTitulo(): void {
    this.tituloRelatorio = "Relatório de Contas ";

    if (!this.checkPagar) {
      this.tituloRelatorio += "Pagas";
    }
    if (this.checkTodas) {
      this.tituloRelatorio += ' e ';
    }
    if (!this.checkPagas) {
      this.tituloRelatorio += "Pagar " + `(${this.filtros.Liberados === 'SIM' ? 'Liberadas' : 'Não Liberadas'})`;
    }
  }

  async pesquisar(): Promise<void> {
    this.montaTitulo();
    this.dataRelatorio = new Date();

    this.relatorio = [];
    this.relatorioPagarPagas = [];

    if (this.checkPagar === true) {
      await this.PesquisarPagar();
    }
    if (this.checkPagas === true) {
      await this.PesquisarPagas();
    }
    if (this.checkTodas === true) {
      //TODO: Analisar e Refatorar para uma linha que puxe todas, sem essa consulta "dupla"
      this.PesquisarPagar()
        .then((resultadoPagar) => {
          this.PesquisarPagas()
            .then((resultadoPagas) => {
              this.relatorioPagarPagas = [...resultadoPagar, ...resultadoPagas];
              this.relatorio = [];
              this.pesquisando = false;
            })
        }
        );
    }
  }

  showToastrIfEmpty(result: any[], message: string) {
    if (result.length === 0) {
      this.toastr.info(message);
    }
  }

  get sortData() {
    if (this.filtros.TipoData === 'Vencimento') {
      if (this.relatorioPagarPagas) {
        return this.relatorioPagarPagas.sort((a, b) => {
          return <any>new Date(a.DataVencimento) - <any>new Date(b.DataVencimento);
        });
      }
    } else {
      if (this.relatorioPagarPagas) {
        return this.relatorioPagarPagas.sort((a, b) => {
          return <any>new Date(a.DataEmissao) - <any>new Date(b.DataEmissao);
        });
      }
    }
  }

  async PesquisarPagar(): Promise<ContasPagar[]> {
    this.pesquisando = true;
    let relatorioPagar = new Array<ContasPagar>();

    await this.relatorioService.pagar(this.filtros).toPromise().then((data) => {
      this.relatorio = relatorioPagar = data;
      this.somaSaldo(data, 'pagar');
      this.pesquisando = false;
      this.showToastrIfEmpty(this.relatorio, "Busca não encontrou resultados para 'pagar'");
    },
      () => {
        this.pesquisando = false
        this.toastr.warning("Realize a pesquisa novamente.")
      }
    );

    return relatorioPagar;
  }

  async PesquisarPagas(): Promise<ContasPagar[]> {
    this.pesquisando = true;
    let relatorioPagas = new Array<ContasPagar>();

    await this.relatorioService.pagas(this.filtros).toPromise().then((data) => {
      this.relatorio = relatorioPagas = data;
      this.somaSaldo(data, 'pagas');
      this.pesquisando = false;
      this.showToastrIfEmpty(this.relatorio, "Busca não encontrou resultados para 'pagar'");
    },
      () => {
        this.pesquisando = false
        this.toastr.warning("Realize a pesquisa novamente.")
      }
    );

    return relatorioPagas;

  }

  public somaSaldo(relatorioResultante: ContasPagar[], tipo: string): void {
    if (tipo === 'pagas') {
      this.totalPagas = 0;
      relatorioResultante.forEach(
        element => this.totalPagas += element.ValorPago
      );
    }
    if (tipo === 'pagar') {
      this.totalPagar = 0;
      relatorioResultante.forEach(
        element => this.totalPagar += element.ValorRestante
      );
    }
  }

  // public SomaSaldoTodas(): void {
  //   this.totalPagas = 0;
  //   this.relatorio.forEach(element => { this.totalPagas += element.Valor; });

  //   this.totalPagar = 0; this.totalLiberadoPagar = 0;
  //   this.relatorio.forEach(element => { this.totalPagar += element.Valor; });
  //   this.relatorio.filter(x => x.Liberada === 'SIM').forEach(element => { this.totalLiberadoPagar += element.Valor; });
  // }

  async controleCheckbox(parametro: 'PAGAS' | 'PAGAR' | 'TODAS', evento: Event): Promise<void> {

    if (!(evento.target as HTMLInputElement).checked) {
      return;
    }

    this.checkPagas = (parametro === 'PAGAS');
    this.checkPagar = (parametro === 'PAGAR');
    this.checkTodas = (parametro === 'TODAS');

    if (!this.checkPagas && this.filtros.TipoData === "Pagamento") {
      this.filtros.TipoData = "Vencimento";
    }

    await this.pesquisar();
  }

  async controleLiberados(liberados: 'SIM' | 'NÃO') {
    this.filtros.Liberados = liberados;

    await this.pesquisar();
  }


  @ViewChild('relatorioContasPagas') relatorioContasPagas: ElementRef;
  imprimirRealtorioContasPagas() {
    let conteudo = document.getElementById("relatorioContasPagas").innerHTML;
    UtilitarioService.imprimirHTML(conteudo, "Relatório contas pagas", this.montaImpressaoFiltros());
  }

  @ViewChild('relatorioContasPagar') relatorioContasPagar: ElementRef;
  imprimirContasPagar() {
    let conteudo = document.getElementById("relatorioContasPagar").innerHTML;
    UtilitarioService.imprimirHTML(conteudo, "Relatório contas a pagar", this.montaImpressaoFiltros());
  }

  @ViewChild('relatorioContasPagasPagar') relatorioContasPagasPagar: ElementRef;
  imprimirRelatorioContasPagasPagar() {
    let conteudo = document.getElementById("relatorioContasPagasPagar").innerHTML;
    UtilitarioService.imprimirHTML(conteudo, "Relatório contas pagas e pagar", this.montaImpressaoFiltros());
  }

  private montaImpressaoFiltros(){
    let objetoFiltros = new Map<string, string>();
    
    adicionaMapValido('Emitido em', this.dataRelatorio.toLocaleString());
    adicionaMapValido('Cod. Processo', this.filtros.ProcessoId);

    if (this.filtros.UnidadeId.length > 1){
      let unidades = '';
      for(var i = 0; i <  this.filtros.UnidadeId.length; i++)
      {
        if(i === (this.filtros.UnidadeId.length - 1))
        {
          unidades += this.lstUnidades.find(y => y.Id === this.filtros.UnidadeId[i]).Descricao;
        }
        else
        {
          unidades += (this.lstUnidades.find(y => y.Id === this.filtros.UnidadeId[i]).Descricao) + ', ';
        }
      }
      adicionaMapValido('Unidades', unidades);
    }
    else if(this.filtros.UnidadeId.length === 1)
    {
      obtemDescricaoAdicionaMap('Unidade', this.lstUnidades, this.filtros.UnidadeId[0]);
    }
    
    adicionaMapValido('Participante', this.nomeParticipanteRelatorio);

    parseDateAdicionaMap(this.filtros.TipoData, ' Inicial', this.filtros.DataInicial);
    parseDateAdicionaMap(this.filtros.TipoData, ' Final', this.filtros.DataFinal);

    if(this.checkPagas || this.checkTodas)
      adicionaMapValido("Total Pagas", "R$ " + this.totalPagas.toLocaleString('pt-BR', { minimumFractionDigits: 2 }));

    if(this.checkPagar || this.checkTodas)
      adicionaMapValido("Total a Pagar", "R$ " + this.totalPagar.toLocaleString('pt-BR', { minimumFractionDigits: 2 }));

    function obtemDescricaoAdicionaMap(chave: string, listaItens: IdDescricao[], idItem: number){
      if(idItem){
        let valor = listaItens.find(x => x.Id === idItem).Descricao;
        objetoFiltros.set(chave, valor);
      } 
  }

    function parseDateAdicionaMap(tipoData: string, inicialFinal: string, data: string){
      if(data && data.indexOf('-') >= 0){
        let dataPartes = data.split('-');
        let dataMontada = dataPartes[2] + '/' + dataPartes[1] + '/' + dataPartes[0];
        objetoFiltros.set(tipoData + inicialFinal, dataMontada);
      }
    }

    function adicionaMapValido(chave: string, valor: any){
      if(valor){
        objetoFiltros.set(chave, valor.toString());
      }
    }

    let stringHtml = '';

    objetoFiltros.forEach((valor, chave) => {
      stringHtml += `<tr><td>${chave}</td><td>${valor}</td></tr>`;
    })
    return stringHtml;
  }

}


